import { useState } from "react";
import { observer } from "mobx-react";
import LoginPage from "../components/account/login";
import NavbarCart from "./navbar-cart";
import { useAuth } from "../contexts/auth-context";
import { useStores } from "../stores/root-store";
import Sidebar from "./sidebar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHome,
  faShoppingBag,
  faSignInAlt,
  faUser,
  faUtensils,
} from "@fortawesome/free-solid-svg-icons";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";

const NavBarBottom = observer(() => {
  const { pathname } = useLocation();
  const { cartStore } = useStores();
  const { cartItemsCount } = cartStore;
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showUserMenus, setShowUserMenus] = useState(false);
  const { isAuthenticated, isShopAdmin, isShopUser } = useAuth();
  const isTableOrderRoute = pathname.includes("/tbl-orders");

  return (
    <nav
      className={`mobile-bottom-nav ${
        isTableOrderRoute ? "table-order-bottom-nav" : ""
      }`}
      aria-label="Mobile navigation"
    >
      <div className="mobile-bottom-nav-inner">
        <Link to="/" className="mobile-bottom-link">
          <FontAwesomeIcon icon={faHome} />
          <span>Home</span>
        </Link>
        <Link
          to={isTableOrderRoute ? "/tbl-orders" : "/prods"}
          className={`mobile-bottom-link ${isTableOrderRoute ? "active" : ""}`}
        >
          <FontAwesomeIcon icon={faUtensils} />
          <span>Menu</span>
        </Link>
        {(!isAuthenticated ||
          (!isShopAdmin && !isShopUser) ||
          isTableOrderRoute) && (
          <NavbarCart cartItemsCount={cartItemsCount} showLabel />
        )}
        {isAuthenticated ? (
          <>
            <Link
              to={isShopAdmin || isShopUser ? "/orders" : "/my-orders"}
              className="mobile-bottom-link"
            >
              <FontAwesomeIcon icon={faShoppingBag} />
              <span>Orders</span>
            </Link>
            <div className="mobile-bottom-item">
              <button
                type="button"
                className="mobile-bottom-link"
                onClick={() => setShowUserMenus(true)}
              >
                <FontAwesomeIcon icon={faUser} />
                <span>Account</span>
              </button>

              {showUserMenus && (
                <Sidebar show={showUserMenus} setShowModal={setShowUserMenus} />
              )}
            </div>
          </>
        ) : (
          <div className="mobile-bottom-item">
            <button
              type="button"
              className="mobile-bottom-link"
              onClick={() => setShowLoginModal(true)}
            >
              <FontAwesomeIcon icon={faSignInAlt} />
              <span>Sign in</span>
            </button>
            {showLoginModal && (
              <LoginPage
                show={showLoginModal}
                setShowModal={setShowLoginModal}
              ></LoginPage>
            )}
          </div>
        )}
      </div>
    </nav>
  );
});

export default NavBarBottom;
